import { API_URLS } from '@bg-shared/constants/apiUrls';
import HttpClientRepository from '@bg-shared/infrastructure/HttpClient/HttpClient.repository';

export default class FavoriteOptionsApi {
    constructor(private readonly httpClient: HttpClientRepository) {}

    public save(id: number): Promise<void> {
        return this.httpClient.post(`${API_URLS.FAVORITE_ODD}/${id}`);
    }

    public remove(id: number): Promise<void> {
        return this.httpClient.remove(`${API_URLS.FAVORITE_ODD}/${id}`);
    }
}
